module.exports = "/ui/images/images/slick-next-sm.png?c8cccbeecdf836397aa763494fbfd32c";